<div class="modal-header">
  <h4 class="modal-title pull-left">&nbsp;</h4>
  <button
    type="button"
    class="close pull-right circle-icon"
    aria-label="Close"
    role="button"
    (click)="hideAndReset()"
  >
    <img src="../assets/images/cross.svg" />
  </button>
</div>
<div class="modal-body">
  <div class="suspended-box">
    <img
      alt="suspended-icon"
      class="suspended-icon"
      src="/assets/images/deactivate_user.svg"
    />
    <h1 class="main-hdg">Your account has been suspended!</h1>
    <p class="des">
      To reinstate your account registered with email
      <br />
      <span>{{ email }},</span>
    </p>
    <p class="des mb-4 pb-0 pb-md-3">
      please reach out to us on "<a
        [href]="'mailto:' + serviceEmail"
        class="disabled-text"
        >{{ serviceEmail }}</a
      >"
    </p>
    <p class="thanks m-0">
      Our team will respond back you about your account status. Thanks.
    </p>
  </div>
</div>
